import React, { useState, useEffect } from 'react'
import { Button, Modal } from 'react-bootstrap'
import Toggle from 'react-toggle'
import { toastr } from 'react-redux-toastr'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import '../../dump/menuComponents/menuComponents.sass'
import 'react-toggle/style.css'
import 'react-dual-listbox/lib/react-dual-listbox.css'

import NotificationsModal from '../modals/NotificationsModal'
import DisableSMSModal from '../modals/DisableSMSModal'
import NotificationToggle from './NotificationToggle'
import { getCompanyByName, updateCompany } from '../../../action/CompaniesActions'
import { updateUserNotifications } from '../../../action/AccountActions'
import { updateFleetUser } from '../../../action/ClientActions'
import { isInternalUser } from '../../helpers/constants'
import { getNotificationCategories } from '../../helpers/helperNotificationCategories'
import CustomButton from '../../CustomButton'
import { getCustomDV7Access, getDV7Access } from '../../helpers/helperDV7Access';

const AccountNotificationsContainer = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'accountPage.accountNotificationsContainer' });
	const { company, readOnly, user, notifications, userEmail, userRole, loaderModal, toggleLoaderModal } = props;

	const DV7access = getDV7Access(company.company_id);
	const customDV7Access = getCustomDV7Access(company.company_id);

	const { roadEventNotifications, cameraStatusNotifications, fleetStatusNotifications, adminNotifications } = getNotificationCategories(DV7access, customDV7Access);

	const [notificationsModal, setNotificationsModal] = useState(false);
	const [selectedNotification, setSelectedNotification] = useState(null);
	const [selectedTitle, setSelectedTitle] = useState(null);
	const [disableSMSModal, setDisableSMSModal] = useState(false);
	const [dmsCutoffModal, setDmsCutoffModal] = useState(false);
	const [selectedName, setSelectedName] = useState(null);
	const [dms_notifs_cutoff, setDms_notifs_cutoff] = useState(null);

	useEffect(() => {
		if (isInternalUser(userRole)) {
			if (company.name && company.partner) {
				getCompanyByName(userRole, company.name, company.partner, 'dms_notifs_cutoff')
					.then(res => {
						setDms_notifs_cutoff(res.data.response.company.dms_notifs_cutoff);
					})
			}
		}
	}, [company.name]);

	// // Only for Tenna and internal users (FWSD-7355)
	// useEffect(() => {
	// 	if ((user?.partner_company_name === "TENNA LLC" || user?.company_name === "Tenna LLC" || isInternalUser(user.roles[0]))) {
	// 		roadEventNotifications.subcategories[0].notifsArr.push({
	// 			name: 'camera_block',
	// 			title: 'Potential Ch2 Obstruction',
	// 			description: 'Sends notification every time a camera generates an event by an auxillary device.',
	// 		})
	// 	}
	// }, []);

	const showNotificationsModal = (e, title) => {
		const name = e.target.name;
		const selectedNotification = name !== 'input_sensor' ? notifications[name] : [notifications.inputsensor1, notifications.inputsensor2, notifications.inputsensor3, notifications.inputsensor4]
		setNotificationsModal(true)
		setSelectedNotification(selectedNotification)
		setSelectedName(name)
		setSelectedTitle(title)
	};

	const updateNotifications = (data) => {
		const { phone_number, sms, voice } = data;

		let reqArray = [];
		reqArray.push(updateUserNotifications(userEmail, data))
		if ((sms || voice) && phone_number && phone_number !== user.phone_number) {
			let updatedSettings = {
				user_email: user.email,
				user_role: user.roles[0],
				data: {
					phone_number: phone_number,
				},
			}
			reqArray.push(updateFleetUser(updatedSettings))
		}
		toggleLoaderModal(true);
		Promise.all(reqArray)
			.then(res => {
				toastr.success(t('updatedNotificationSettings'))
				toggleLoaderModal(false);
				if (res[1] && res[1].data && !readOnly) {
					props.updateUser(res[1].data.response.user);
				}
				setNotificationsModal(false)
				props.getNotifications()
			})
			.catch(err => {
				toastr.error(t('issueUpdatingNotificationSettings'))
				toggleLoaderModal(false);
				setNotificationsModal(false)
			})
	};

	const disableAllSMS = (notifsWithSMS) => {
		toggleLoaderModal(true)
		const data = {}
		for (let notif of Object.keys(notifsWithSMS)) {
			data[notif] = { ...notifsWithSMS[notif], ...{ sms: false, vehicles: [] } }
		}
		updateUserNotifications(props.userEmail, data)
			.then(res => {
				toastr.success(t('disabledSMSnotifications'))
				toggleLoaderModal(false)
				setDisableSMSModal(false)
				props.getNotifications()
			})
			.catch(err => {
				toastr.error(t('unableDisableSMSnotifications'))
				toggleLoaderModal(false)
				setDisableSMSModal(false)
			})
	};

	const changeDMSCutoff = (agreed = null) => {
		if (agreed) {
			updateCompany({ data: { dms_notifs_cutoff: dms_notifs_cutoff }, company: { owner_company: company.partner, company_name: company.name } }, user.roles[0])
				.then(res => {
					toastr.success(t('updatedDMSCutoff'))
				})
				.catch(err => {
					toastr.error(t('unableUpdate'))
				})
		}
		else {
			setDms_notifs_cutoff(-1)
		}
		setDmsCutoffModal(false)
	};

	let recordingStatusDisabled = false;
	if (['system_admin', 'customer_service', 'partner', 'partner_view', 'sales_demo', 'installer'].indexOf(userRole) > -1) {
		recordingStatusDisabled = true;
	};

	if (!notifications) {
		return (<div></div>)
	};

	const auxInputEmail = notifications.inputsensor1 && (notifications.inputsensor1.email || notifications.inputsensor2.email || notifications.inputsensor3.email || notifications.inputsensor4.email);
	const auxInputSms = notifications.inputsensor1 && (notifications.inputsensor1.sms || notifications.inputsensor2.sms || notifications.inputsensor3.sms || notifications.inputsensor4.sms);

	const notifsWithSMS = {}
	if (!['storage_manager', 'storage_user'].includes(userRole)) {
		for (let notif of Object.keys(notifications)) {
			if (notifications[notif].sms) {
				notifsWithSMS[notif] = { ...notifications[notif] }
			}
		}
	}

	return (
		<section className="user-notifications">
			{!['storage_manager', 'storage_user'].includes(userRole) ? (
				<div className="notifications-container">
					<div className="title-flex">
						<h3 className="category-title">
							{t('titleEventNotifications')}
						</h3>
						{user.email !== userEmail && !readOnly && Object.entries(notifsWithSMS).length > 0 && (
							<CustomButton variant="primary-outline" size="sm" onClick={() => setDisableSMSModal(true)}>
								{t('btnDisableSMS')}
							</CustomButton>
						)}
					</div>
					{roadEventNotifications.subcategories.map(subcategory => (
						<div key={subcategory.title}>
							<h5 className="category-subtitle">
								{t(subcategory.title.replace(/\s/g, "_"))}
								{subcategory.title === 'DMS Events' && isInternalUser(userRole) && (
									<div className="dms-cutoff-select">
										{t('DMS_Notifications_Cutoff')}
										<select
											value={dms_notifs_cutoff || (dms_notifs_cutoff === 0 ? 0 : -1)}
											onChange={(e) => {
												setDms_notifs_cutoff(e.target.value * 1);
												setDmsCutoffModal(true);
											}}
										>
											<option value="-1">{t('optionNone')}</option>
											<option value="5">{t('option5minutes')}</option>
											<option value="30">{t('option30minutes')}</option>
											<option value="60">{t('option1hour')}</option>
											<option value="1440">{t('option24hours')}</option>
											<option value="0">{t('optionNever')}</option>
										</select>
									</div>
								)}
							</h5>
							<div className="two-column-grid with-margin notifications-grid">
								{subcategory.notifsArr.map(category => (
									<NotificationToggle
										userRole={userRole}
										name={category.name}
										title={t(category.title.replace(/\s/g, "_"))}
										description={t(category.title.replace(/\s/g, "_") + '_description')}
										readOnly={readOnly}
										key={category.name}
										email={category.name !== 'input_sensor' ? notifications[category.name]?.email : auxInputEmail}
										sms={category.name !== 'input_sensor' ? notifications[category.name]?.sms : auxInputSms}
										voice={category.name === 'drowsiness' ? notifications[category.name]?.voice : undefined}
										onChange={(e) => showNotificationsModal(e, category.title)}
									/>
								))}
							</div>
						</div>
					))}

					<h3 className="category-title">{t('titleCameraHealthNotifications')}</h3>
					<div className="two-column-grid with-margin notifications-grid">
						{cameraStatusNotifications.map(notification => (
							<NotificationToggle
								userRole={userRole}
								{...notification}
								title={t(notification.title.replace(/\s/g, "_"))}
								description={t(notification.title.replace(/\s/g, "_") + '_description')}
								readOnly={notification.disabled ? notification.disabled : readOnly}
								key={notification.name}
								email={!notification.disabled ? notifications[notification.name]?.email : ''}
								sms={!notification.disabled ? notifications[notification.name]?.sms : ''}
								onChange={(e) => showNotificationsModal(e, notification.title)}
							/>
						))}
					</div>

					<h3 className="category-title">{t('titleFleetStatusNotifications')}</h3>
					<div className="two-column-grid with-margin notifications-grid">
						{fleetStatusNotifications.map(notification =>
							<NotificationToggle
								userRole={userRole}
								{...notification}
								title={t(notification.title.replace(/\s/g, "_"))}
								description={t(notification.title.replace(/\s/g, "_") + '_description')}
								readOnly={readOnly}
								key={notification.name}
								tooltip={(notification.title === 'Recording Status' && recordingStatusDisabled) && t('tooltip')}
								email={notifications[notification.name].email}
								sms={notifications[notification.name].sms}
								onChange={(e) => showNotificationsModal(e, notification.title)}
							/>,
						)}
					</div>
					{['system_admin', 'customer_service'].includes(userRole) && (
						<div>
							<h3 className="category-title">{t('titleAdminNotifications')}</h3>
							<div className="two-column-grid with-margin notifications-grid">
								{adminNotifications.map(notification =>
									<NotificationToggle
										userRole={userRole}
										{...notification}
										title={t(notification.title.replace(/\s/g, "_"))}
										description={t(notification.title.replace(/\s/g, "_") + '_description')}
										readOnly={readOnly}
										key={notification.name}
										// tooltip={(notification.title === 'Recording Status' && recordingStatusDisabled) && 'This report is not available for multi-company users. To receive this report, add a user to this company with fleet manager or lower permissions'}
										email={notifications[notification.name]?.email}
										sms={notifications[notification.name]?.sms}
										onChange={(e) => showNotificationsModal(e, notification.title)}
									/>,
								)}
							</div>
						</div>
					)}
				</div>
			) : (
				<div className="notifications-container">

					<h3 className="category-title">{t('titleEmailNotifications')}</h3>
					<div className="two-column-grid with-margin notifications-grid">
						<div className="notification-wrapper">
							<label className="toggles">
								<span className="notification-title">{t('titleChannelFailure')}</span>
								<span>
									<Toggle
										disabled={readOnly}
										name="alert_camera_failure"
										checked={!!notifications.alert_camera_failure}
										onChange={props.fillForm}
									/>
								</span>
							</label>
							<div className="description">{t('descriptionChannelFailure')}</div>
						</div>
						<div className="notification-wrapper">
							<label className="toggles">
								<span className="notification-title">{t('titleInactiveVehicles')}</span>
								<span>
									<Toggle
										disabled={readOnly}
										name="alert_inactive_vehicles"
										checked={!!notifications.alert_inactive_vehicles}
										onChange={props.fillForm}
									/>
								</span>
							</label>
							<div className="description">{t('descriptionInactiveVehicles')}</div>
						</div>
						<div className="notification-wrapper">
							<label className="toggles">
								<span className="notification-title">{t('titleAuditNotification')}</span>
								<span>
									<Toggle
										disabled={readOnly}
										name="audit_notification"
										checked={!!notifications.audit_notification}
										onChange={props.fillForm}
									/>
								</span>
							</label>
							<div className="description">{t('descriptionAuditNotification')}</div>
						</div>
					</div>
				</div>
			)}
			{notificationsModal && (
				<NotificationsModal
					notification={selectedNotification}
					selectedName={selectedName}
					selectedTitle={selectedTitle}
					hideNotificationsModal={() => setNotificationsModal(false)}
					updateNotifications={updateNotifications}
					userEmail={userEmail}
					readOnly={userEmail !== user.email}
				/>
			)}
			{disableSMSModal && (
				<DisableSMSModal
					hideDisableSMSModal={() => setDisableSMSModal(false)}
					disableAllSMS={() => disableAllSMS(notifsWithSMS)}
				/>
			)}
			{dmsCutoffModal && (
				<Modal
					show
					onHide={() => changeDMSCutoff(false)}
					className="notifications-modal modal-lg-size"
				>
					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-lg">{t('titleChangeDMSCutoff')}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="notifications-modal-body modal-text">
							<span className="error-label">{t('labelWarning')}</span> {t('labelWarningText_1')}
							<strong> {props.company.name}</strong>. {t('labelWarningText_2')}
						</div>
					</Modal.Body>
					<Modal.Footer>
						<CustomButton variant='delete' onClick={() => changeDMSCutoff(false)}>{t('btnCancel')}</CustomButton>
						<CustomButton variant='primary' onClick={() => changeDMSCutoff(true)}>{t('btnApply')}</CustomButton>
					</Modal.Footer>
					{loaderModal}
				</Modal>
			)}
		</section>
	)
}

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company,
		loaderModal: state.loader.loaderModal
	}),
	dispatch => ({
		updateUser: (user) => {
			dispatch({ type: 'GET_USER_SUCCESS', payload: user });
		},
		toggleLoaderModal: (show) => {
			dispatch({ type: 'TOGGLE_LOADER_MODAL', payload: show });
		}
	})
)(AccountNotificationsContainer);
